import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { AppleSignInDiv, ButtonText, ImageWrapper } from './AppleLoginButton.styles';
// @ts-expect-error not converted to TS
import Image from '../../images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppleLoginButton = ({
  onClick,
  disabled,
  smartLogin
}) => /*#__PURE__*/_jsx(UIButton, {
  "data-test-id": "apple-sign-in",
  className: "apple-sign-in width-100 m-left-0",
  use: "unstyled",
  onClick: onClick,
  disabled: disabled,
  children: /*#__PURE__*/_jsxs(AppleSignInDiv, {
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(ImageWrapper, {
      disabled: disabled,
      children: /*#__PURE__*/_jsx(UIImage, {
        src: Image.appleLogo
      })
    }), /*#__PURE__*/_jsx(ButtonText, {
      children: smartLogin ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.form.apple"
      }) : /*#__PURE__*/_jsx(UITruncateString, {
        reverse: true,
        maxWidth: 150,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.apple"
        })
      })
    })]
  })
});
export default AppleLoginButton;